<template>
    <div id="app-container" class="app-container-box">
      <div class="list-container-box">
       
        <van-list
          class="list-box"
          finished-text="没有更多了"
          :loading="list_loading"
          :finished="list_load_all"
          :immediate-check="false"
          @load="onLoadListen"
          v-if="check_list.length > 0"
        >
          <div
            class="list-item"
            v-for="item in check_list"
            :key="item.id"
            @click="enterItemDetail(item)"
          >
            <div class="item-header">
              <div class="header-left">
                <span class="dot" v-if="item.isread == 0"></span>
                <img class="img_label" v-if="item.istop == 1" src="../../assets/icon_top.png"/><span class="title" :class="{ title_top: item.istop == 1 }">{{ item.title }}</span>
              </div>
              <img
                class="header-img"
                v-lazy="item.image_fmt + '?width=200'"
                alt=""
              />
            </div>
            <div class="item-footer">
              <span class="footer-time">{{ item.create_time_fmt }}</span>
            </div>
          </div>
        </van-list>
        <van-empty
          description="暂无数据"
          v-else-if="check_list.length == 0 && list_loading == false"
        />
      </div>
  
      <div class="loading-box" v-if="list_loading">
        <van-loading color="#ffffff" vertical>加载中...</van-loading>
      </div>
    </div>
  </template>
  <script setup>
  import { ref, onMounted } from "vue";
  import req from "@/js/req";
  import { useRouter } from "vue-router";
  import User from "@/js/user";
  
  const router = useRouter();
  const list_loading = ref(false);
  const list_load_all = ref(false);
  const check_list = ref([]);
  
  
  let page = 1;
  const limit = 10;

  
  onMounted(() => {
     getNoticeList()
  });
  
 
  const onLoadListen = () => {
    page += 1;
    getNoticeList();
  };
  const refleshiLoad = () => {
    page = 1;
    check_list.value = [];
    list_load_all.value = false;
    list_loading.value = false;
    getCheckList();
  };

 
  const getNoticeList = async () => {
    
    list_loading.value = true;
  
    let param = {
      page: page,
      limit: limit,
      ...User.getUTP(),
    };

    let data = await req.get(req.path.get_notice_list, param);
    check_list.value = [...check_list.value, ...data.list];
    list_loading.value = false;
    if (check_list.value.length >= data.total) {
      list_load_all.value = true;
    }
  };


  const enterItemDetail = (item) => {
    
    router.push({
      path: "/notice-detail",
      query: {
        type: item.type,
        content: item.type == 1? item.content : item.link
      },
    });
    if (item.isread == 0) {
        mardNoticeisRead(item);
    }
  };
  const mardNoticeisRead = async (item) => {
  const p = {
    info_id: item.info_id,
  };
  await req.post(req.path.set_notice_mark, p);
  item.isread = 1;
  User.getInstance()._notice_unread_count.value -= 1;
};
  // const getListImage = (s) => {
  //   const last_s = s.split('/').pop().split('.').pop()
  //   const substr = s.substr(0,s.length - last_s.length - 1)
  //   const n_s = `${substr}_400.${last_s}`
  //   return n_s
  // };
  </script>
  <style lang="scss" scoped>
  .app-container-box {
    position: relative;
    .list-container-box {
      padding: 16px;
      padding-top: 0px;
      padding-bottom: var(--van-tabbar-height);
      .type-header {
        display: flex;
        // justify-content: space-between;
        flex-direction: row;
        flex-wrap: wrap;
        .type-button {
          // padding: 0px 40px;
          margin-top: 20px;
          width: 340px;
          margin-right: 30px;
          &:nth-of-type(2n) {
            margin-right: 0px;
          }
        }
      }
      .list-box {
        .list-item {
          // height: 305px;
          margin-top: 32px;
          background-color: white;
          box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.2);
          border-radius: 8px;
          .item-header {
            display: flex;
            justify-content: space-between;
            padding: 24px 0px 0px;
            margin: 0 24px;
            .header-left {
               margin-right: 26px;
               position: relative;
               display: flex;
               .title{
                  font-size: 28px;
                  color: rgba(0, 7, 18, 0.80);
                  text-align: justify;
                  display: inline-block;
                  
               }
               .title_top{
                text-indent: 80px; 
               }
               .img_label{
                  position: absolute;
                  width: 72px;
                  height: 32px;
               }
               .dot{
                  display: inline-block;
                  width: 8px;
                  height: 8px;
                  background-color: red;
                  position: absolute;
                  left: -15px;
                  top: 14px;
                  border-radius: 100%;
               }
  
            
            }
            .header-img {
              width: 200px;
              height: 150px;
              flex-shrink: 0;
              display: inline-block;
              object-fit: cover;
              background-image: url(../../assets/placeholder.jpg);
              background-size: 100% 100%;
              background-repeat: no-repeat;
              border-radius: 8px;
            }
          }
          .item-footer {
            font-size: 22px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 24px;
            .footer-time {
              color: var(--c-text-color-gray-6);
            }
            .footer-text {
              color: var(--c-text-color-red);
              display: flex;
              align-items: center;
            }
            .footer-img {
              width: 40px;
              height: 40px;
              margin-left: 12px;
            }
          }
        }
      }
    }
  }

  .loading-box {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
  }
  ::v-deep .van-loading {
    background-color: rgba(0, 0, 0, 0.6);
    padding: 50px;
    border-radius: 10px;
  }
  ::v-deep .van-button--default {
  }
  </style>
  